import { useLayoutEffect } from "react";
import {
  spaceTabBarLayoutCssVars,
  SPACE_TAB_BAR_LAYOUT,
  type SpaceTabBarLayoutConfig,
} from "../space/common/SpaceTabBarConfig";

const DEBUG_CLASS = "lf-h5-tab-bar-debug";

/** Tab 栏 Portal 到 body；布局变量写在 html 上供全局继承 */
export function useSpaceTabBarLayoutVars(
  enabled = true,
  layout: SpaceTabBarLayoutConfig = SPACE_TAB_BAR_LAYOUT
): void {
  useLayoutEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const vars = spaceTabBarLayoutCssVars(layout);
    const root = document.documentElement;

    Object.entries(vars).forEach(([key, value]) => {
      if (value != null) {
        root.style.setProperty(key, String(value));
      }
    });
    if (layout.showRegionDebugColors) {
      root.classList.add(DEBUG_CLASS);
    }

    return () => {
      Object.keys(vars).forEach((key) => root.style.removeProperty(key));
      root.classList.remove(DEBUG_CLASS);
    };
  }, [enabled, layout]);
}
